// Import required functions
import { createEntityAdapter } from "@reduxjs/toolkit";
import apiSlice from "../api/apiSlice";

const sizingMeterStaticParametersAdapter = createEntityAdapter({});
const initialStaticState = sizingMeterStaticParametersAdapter.getInitialState({});

// Extend the API slice
export const meterStaticParametersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get Static Meter Parameters by Meter ID
    getMeterStaticParametersByMeterId: builder.query({
      query: ({ communityId, meterId }) => ({
        url: `/communities/${communityId}/sizing_meter_static_parameters/${meterId}`,
        method: "GET",
        validateStatus: (response, result) => response.status === 200 && !result?.isError,
      }),
      transformResponse: (responseData) =>
        responseData
          ? sizingMeterStaticParametersAdapter.setAll(initialStaticState, responseData)
          : [],
      providesTags: (result) => {
        if (result?.ids) {
          return [
            { type: "SizingMeterStaticParameter", id: "LIST" },
            ...result.ids.map((id) => ({ type: "SizingMeterStaticParameter", id })),
          ];
        }
        return [{ type: "SizingMeterStaticParameter", id: "LIST" }];
      },
    }),

    addMeterStaticParameter: builder.mutation({
      query: ({ communityId, parameterData }) => ({
        url: `/communities/${communityId}/sizing_meter_static_parameters`,
        method: "POST",
        body: parameterData,
      }),
      invalidatesTags: [{ type: "SizingMeterStaticParameter", id: "LIST" }],
    }),

    // Update Static Meter Parameters
    updateMeterStaticParameter: builder.mutation({
      query: ({ communityId, parameterId, updatedData }) => ({
        url: `/communities/${communityId}/sizing_meter_static_parameters/${parameterId}`,
        method: "PUT",
        body: updatedData,
      }),
      invalidatesTags: [{ type: "SizingMeterStaticParameter", id: "LIST" }],
    }),
  }),
});

export const {
  useGetMeterStaticParametersByMeterIdQuery,
  useAddMeterStaticParameterMutation,
  useUpdateMeterStaticParameterMutation,
} = meterStaticParametersApiSlice;

export const meterStaticParametersApi = meterStaticParametersApiSlice;
